import { render, staticRenderFns } from "./TableEventsReferee.vue?vue&type=template&id=d0956136&scoped=true&"
import script from "./TableEventsReferee.vue?vue&type=script&lang=js&"
export * from "./TableEventsReferee.vue?vue&type=script&lang=js&"
import style0 from "./TableEventsReferee.vue?vue&type=style&index=0&id=d0956136&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0956136",
  null
  
)

export default component.exports